/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, {Component, PropTypes} from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Container } from 'src/components/Common/reactstrap/lib';


class GarageModalAddCar extends React.Component {
  render() {
    return (
      <div>
        {this.props.buttonLabel && <Button className="btn-wide" onClick={this.props.startModal}>{this.props.buttonLabel}</Button>}
        <Modal isOpen={this.props.modal} toggle={this.props.startModal} className={this.props.className}>
          <ModalHeader toggle={this.props.startModal}>{this.props.modalTitle}</ModalHeader>

          <Container>
            {this.props.modalBody}
          </Container>
        </Modal>
      </div>
    );
  }
}

Modal.propTypes = {
  isOpen:  PropTypes.bool,
  // boolean to control the state of the popover
  toggle:  PropTypes.func,
  // callback for toggling isOpen in the controlling component
  size: PropTypes.string,
  // control backdrop, see http://v4-alpha.getbootstrap.com/components/modal/#options
  backdrop: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.oneOf(['static'])
  ]),
  keyboard: PropTypes.bool,
  // zIndex defaults to 1000.
  zIndex: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
};
export default GarageModalAddCar;




/** WEBPACK FOOTER **
 ** ./src/components/User/elements/GarageModalAddCar.jsx
 **/